module.exports = __webpack_public_path__ + "img/icono_G4.79814d69.svg";